import React, { useLayoutEffect } from 'react';
import { each, filter } from 'lodash';
import DesktopBAU from '../bau/desktop';
import { BAU } from '../common/plans_data';

const Cell2 = () => {
  useLayoutEffect(() => {
    each(
      filter(BAU.plans, (plan) => (plan.id !== 1)),
      (plan) => {
        plan.taxPhrase = 'Taxes and fees excluded.';
      }
    );
  }, []);

  return (<DesktopBAU />);
};

export default Cell2;
